export const bulkJobFlows = Object.freeze(
  /** @type {const} */ ({
    REVISE: 'revise',
    RENEW: 'renew',
  })
);
